<p class="mb-08 ml-12">{{ "simulationParams.payoutAge" | fms }}</p>

<ng-container *appLet="open$ | async as open">
  <button
    class="panel-toggle"
    [stbButton]="'outlined'"
    [rebrand]="true"
    [class.open]="open"
    [size]="(simulationParametersByEngagementEnable$ | async) ? 'medium' : 'large'"
    (click)="togglePanel()"
    [attr.aria-expanded]="open"
    [iconType]="open ? 'chevron-up' : 'chevron-down'"
    [setIconAfter]="true"
  >
    @if (simulationParametersByEngagementEnable$ | async) {
      {{ "startPayoutAgeFormField.option.custom" | fms }}
    } @else {
      {{ startPayoutAge$ | async }}&nbsp;{{ "agreement_details.duration.years" | fms }}
    }
  </button>

  <app-simulation-params-panel [open]="open" (close)="closePanel()"></app-simulation-params-panel>
</ng-container>
